import {
	RegistrZPVztahOsoby,
	useServiceAuthorization,
} from '@gov-nx/core/hooks';

// The service maps to two distinct authorization codes depending on the
// selected vztah osoby (see prepareSubmitData / zdrojUdaju). Keep this file as
// the single source of truth for that mapping so the runtime handoff
// (getAuthorizationServiceName) and the UI flags (useNeverejnyVypisZZRAuthorization)
// can never drift apart.
export const AUTHORIZATION_SERVICE_NAME_VYPIS_K_OSOBE = 'RZP_PREHLED_O_UDAJICH';
export const AUTHORIZATION_SERVICE_NAME_VYPIS_PS = 'RZP_VYPIS_UDAJU_PS';

/**
 * Resolves the authorization code the runtime handoff (`onInitAuthorization`)
 * targets for the selected vztah osoby. This is branch-sensitive by design.
 */
export const getAuthorizationServiceName = (
	vztahOsoby?: RegistrZPVztahOsoby
) =>
	vztahOsoby === RegistrZPVztahOsoby.VYPIS_UDAJU_PRO_SUBJEKT_S_VAZBOU_K_ME_OSOBE
		? AUTHORIZATION_SERVICE_NAME_VYPIS_PS
		: AUTHORIZATION_SERVICE_NAME_VYPIS_K_OSOBE;

export type ServiceAuthorization = ReturnType<typeof useServiceAuthorization>;

/**
 * Resolves the authorization flags for the *selected* vztah osoby.
 *
 * Both `useServiceAuthorization` calls happen unconditionally (hook rules), but
 * the returned selector routes through the exact same
 * {@link getAuthorizationServiceName} mapping the runtime handoff
 * (`onInitAuthorization`) uses. That keeps the branch-agnostic UI
 * (consent checkbox + "Autorizovat a …" prefix) in lock-step with the
 * branch-sensitive runtime: whatever code will be authorized for the current
 * branch is exactly the code whose config drives the UI. No invariant that the
 * two codes share config is assumed.
 */
export const useNeverejnyVypisZZRAuthorization = () => {
	const kOsobe = useServiceAuthorization(
		AUTHORIZATION_SERVICE_NAME_VYPIS_K_OSOBE
	);
	const ps = useServiceAuthorization(AUTHORIZATION_SERVICE_NAME_VYPIS_PS);

	return (vztahOsoby?: RegistrZPVztahOsoby): ServiceAuthorization =>
		getAuthorizationServiceName(vztahOsoby) ===
		AUTHORIZATION_SERVICE_NAME_VYPIS_PS
			? ps
			: kOsobe;
};
